export interface CategoryMenuItem {
  label: string
  to: string
  navId: string
  enTerm: string
}

export function useCategoryMenuItems() {
  const treeStore = useCategoryTreeStore()
  const localePath = useLocalePath()
  const { locale } = useI18n()

  return computed<CategoryMenuItem[]>(() =>
    treeStore.roots.map((node: CategoryTreeNode) => {
      const slug = treeStore.normalize(node.terms[locale.value] ?? node.terms.de ?? '')
      return {
        label: node.terms[locale.value] ?? node.terms.de ?? '',
        to: localePath(`/c/${slug}`),
        navId: `mobile_menu_category_${slug}`,
        enTerm: node.terms.en ?? node.terms.de ?? '',
      }
    }),
  )
}
